
import React, { useState } from "react";
import { Col, Container, Row, Dropdown } from "react-bootstrap";
import Logo from "../../Asset/Images/logo.svg";
import userIcon from "../../Asset/Images/user-icon.svg";
import logoutIcon from "../../Asset/Images/logout-icon.svg";
import { useNavigate } from "react-router";
import { ssoLogOut } from "../../Services/auth";
import addUserIcon from "../../Asset/Images/add-user-icon.svg";
import coverImgUser from "../../Asset/Images/placeholder-vehicle.png";
import togglMenuIcon from "../../Asset/Images/side-menu-icon.svg";
import Offcanvas from 'react-bootstrap/Offcanvas';



import "./index.css";

const Header = () => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    let navigate = useNavigate();

    let handleLogout = async () => {
        let payload = {
            user_id: localStorage.user_id
        }
        let res = await ssoLogOut(payload)
        if (res && res.status == '200') {
            localStorage.clear()
            navigate('/login')
        }
    }

    let getInitials = (fullName) => {
        const names = fullName.trim().split(" ");
        const firstName = names[0] || "";
        const surname = names[1] || "";

        if (firstName.length > 0 && surname.length > 0) {
            return firstName[0] + surname[0];
        } else if (firstName.length > 0 && surname.length <= 0) {
            return firstName[0];
        } else {
            return "";
        }
    }


    return (
        <header className="header-layout">
            <Container fluid>
                <Row className="align-items-center">
                    <Col xs={6} md={3}>
                        <div className="logo">
                            <span className="logo-brand"><img src={Logo} alt="logo" /></span>
                        </div>
                    </Col>
                    <Col xs={6} md={9}>
                        <div className="side-menubutton text-end d-md-none"><button className="btn p-0 border-0" onClick={handleShow}><img src={togglMenuIcon} /></button></div>
                        <div className="right-side-items text-end">
                            <div className="menu-bar-nav">
                                <ul className="main-menu-itms p-0 m-0">
                                    {/* <li className="add-users-button"><button type="button" className="btn add-user-icon" onClick={() => navigate('/users')}><img src={addUserIcon} alt="" /></button></li> */}
                                    <li onClick={() => navigate('/dashboard')} className="items-menu-nv"><span className={`lnk-txt-menu ${window.location.pathname.includes('dashboard') ? 'active' : ''}`}>Dashboard</span></li>
                                    <li onClick={() => navigate('/template/deploy')} className="items-menu-nv"><span className={`lnk-txt-menu ${window.location.pathname.includes('template') || window.location.pathname == '' ? 'active' : ''}`}>Add New Request</span></li>
                                </ul>
                            </div>
                            <div className="right-side-menu">
                                {/* <button onClick={handleLogout} type="button" className="btn p-0 border-0 logo-out-btn"><img src={logoutIcon} alt="" /></button> */}
                                <Dropdown className="d-inline-block profile-itms-wt">
                                    <Dropdown.Toggle className="user-profile-top p-0 border-0 bg-transparent">
                                        <span className="user-profileImg">{localStorage.name ? getInitials(localStorage.name) : 'S'}</span>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu align="end" className="dropdown-profile-menu p-0">
                                        <div className="bodywap-content-itms">
                                            <div className="d-flex align-items-center justify-content-between px-3 py-2">
                                                <h4 className="mb-0 head-content-wt">S3S</h4>
                                                <div className="logout-elemnt-button"><button onClick={handleLogout} type="button" className="btn p-0 border-0 logoout-view">Sign Out</button> </div>
                                            </div>
                                            <div className="d-flex align-items-center profile-flx-lyt p-3">
                                                <div className="left-cover-pf-img"><span className="user-symbol-txt">{localStorage.name ? getInitials(localStorage.name) : 'S'}</span></div>
                                                <div className="right-side--pfinfo">
                                                    <h3 className="heading-pf-name">{localStorage.name ? localStorage.name : ''}</h3>
                                                    {/* <h3 className="heading-pf-name">{localStorage.name ? localStorage.name : ''}</h3> */}

                                                    <span className="d-block inf-eml-txt">{localStorage.role ? localStorage.role : ''}</span>
                                                    {
                                                        localStorage && localStorage.role == 'Admin' ?
                                                            <>
                                                                <div className="list-waptitle "><span onClick={() => navigate('/users')} style={{ color: '#0078d6' }} className="header-dropdn-navgn">Manage Users</span></div>
                                                                <div className="list-waptitle "><span onClick={() => navigate('/lookup')} style={{ color: '#0078d6' }} className="header-dropdn-navgn">Manage Lookup</span></div>
                                                            </>
                                                            :
                                                            null

                                                    }


                                                </div>
                                            </div>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            {/* <span className="user-profile">
                                <img src={userIcon} alt="user" />
                            </span> */}
                        </div>
                    </Col>
                </Row>
            </Container>
            <Offcanvas className="aside-wapper-menu" show={show} onHide={handleClose}>
                <Offcanvas.Header className="p-0 header-button-mdl" closeButton>
                    {/* <div className="logo">
                        <span className="logo-brand"><img src={Logo} alt="logo" /></span>
                    </div> */}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="manage-profile-flx">
                        <div className="manage-boxcard">
                            <div className="profile-flx-wgts">
                                <div className="name-short-txtw"><span className="symt-txt-wap">{localStorage.name ? getInitials(localStorage.name) : 'S'}</span></div>
                                <h3 className="title-nm-log">{localStorage.name ? localStorage.name : ''}</h3>
                            </div>
                            <ul className="lst-rwmlt">
                                <li><span><i className="far fa-user me-1"></i> Admin</span></li>
                                <li><span style={{ cursor: 'pointer' }} onClick={() => navigate('/users')}><i className="fas fa-tasks me-1"></i> Manage Users</span></li>
                                <li><span style={{ cursor: 'pointer' }} onClick={() => navigate('/lookup')}><i class="far fa-file-alt me-1"></i> Manage Lookup</span></li>
                            </ul>
                        </div>
                        <div className="flx-signwds">
                            <button onClick={handleLogout} type="button" className="btn btn-signout-side border-0"><i class="fas fa-sign-out-alt me-1"></i> Sign Out</button>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </header>

    )
}
export default Header;